import { IonListHeader } from '@ionic/react';
import styled, { css } from 'styled-components';

const sharedStyle = css`
  font-weight: 600;
  font-size: 1.375rem; /* 22px */
  line-height: 1.625rem; /* 26px */
`;

export const SectionTitle = styled.h2`
  ${sharedStyle}
`;

export const SectionListHeader = styled(IonListHeader)`
  ${sharedStyle}
`;
